import { Box, FormControl, FormLabel, Typography } from '@mui/material';
import React from 'react';
import { variants } from '../../../../variants/variants';
import { useSelector } from 'react-redux';
import { selectEditForChanges, selectIsStarted, selectRejectReason } from '../../giftSlice';
import { useMediaQuery } from '@mui/material';

const RejectReason = () => {
  const rejectReason = useSelector(selectRejectReason);
  const editForChanges = useSelector(selectEditForChanges);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  return (
    rejectReason && (
      <Box sx={{ flex: 1, border: 0, display: 'flex', alignItems: 'flex-end' }}>
        <FormControl
          component='fieldset'
          sx={{
            width: 1,
            borderRadius: variants.boxRadius.MAIN,
            border: 1,
            borderColor: 'divider',
            p: 1,
          }}
        >
          <FormLabel
            component='legend'
            sx={{
              color: '#229A16',
            }}
          >
            <Typography sx={{ fontSize: variants.BODY }}>Feedback to improve</Typography>
          </FormLabel>
          <div className='content'>
            <Box sx={{ height: editForChanges ? '20vh' : '26vh', overflowY: 'auto', border: 0 }}>
              <Typography sx={{ fontSize: variants.BODY }}>{rejectReason}</Typography>
            </Box>
          </div>
        </FormControl>
      </Box>
    )
  );
};

export default RejectReason;
